import { NextPage } from 'next'
import { serverSideTranslations } from '@/i18n/serverSideTranslations'
import graphQLClient from '@/lib/api/graphQLClient'
import CmsPage from '@/components/models/cms/page/CmsPage'
import { SINGLE_CMS_PAGE_QUERY } from '@/lib/gql'
import SeoHeader from '@/components/elements/seo/SeoHeader'
import { getCmsPagesStaticPaths } from '@/lib/helpers/getStaticPaths'

const CmsSinglePage: NextPage = ({ cmsPage, cmsConfig, travelTypes }: any) => {
  return (
    <>
      <SeoHeader seoSettings={cmsPage.seoSettings} />
      <CmsPage cmsPage={cmsPage} cmsConfig={cmsConfig} travelTypes={travelTypes} />
    </>
  )
}

export async function getStaticProps({ params, locale }: any) {
  const pageSlug = params.slugs[params.slugs.length - 1]
  const data = await graphQLClient.request(SINGLE_CMS_PAGE_QUERY, { tenantId: process.env.NEXT_PUBLIC_TENANT_ID, id: pageSlug }).catch(() => {})
  // data.page ist null, wenn es zum Slug keine Seite gibt -> 404 statt TypeError (500)
  if (params.slugs.length < 2 || !data?.page || !data.tenant.cms.pageIds.includes(data.page.id) || data.page.onlineStatus === 'OFFLINE') {
    return {
      props: {},
      notFound: true,
      revalidate: 10,
    }
  }

  return {
    props: {
      cmsPage: data.page,
      cmsConfig: data.tenant.cms.config,
      travelTypes: data.tenant.travelTypes,
      ...(await serverSideTranslations(locale, ['common', 'theme'])),
    },
    revalidate: 10,
  }
}

export async function getStaticPaths() {
  return {
    paths: await getCmsPagesStaticPaths(),
    fallback: 'blocking',
  }
}

export default CmsSinglePage
